import React, { useState } from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';
import './AdminLayout.css';

/* ── Icons ── */
const IconDashboard = () => (
  <svg viewBox="0 0 24 24" fill="none" width="18" height="18">
    <rect x="3" y="3" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="2"/>
    <rect x="14" y="3" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="2"/>
    <rect x="3" y="14" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="2"/>
    <rect x="14" y="14" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="2"/>
  </svg>
);
const IconFormaciones = () => (
  <svg viewBox="0 0 24 24" fill="none" width="18" height="18">
    <path d="M2 3h6a4 4 0 014 4v14a3 3 0 00-3-3H2zM22 3h-6a4 4 0 00-4 4v14a3 3 0 013-3h7z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);
const IconRecursos = () => (
  <svg viewBox="0 0 24 24" fill="none" width="18" height="18">
    <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M14 2v6h6M9 13h6M9 17h4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);
const IconUsuarios = () => (
  <svg viewBox="0 0 24 24" fill="none" width="18" height="18">
    <circle cx="9" cy="7" r="4" stroke="currentColor" strokeWidth="2"/>
    <path d="M3 21v-2a4 4 0 014-4h4a4 4 0 014 4v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M16 3.13a4 4 0 010 7.75M21 21v-2a4 4 0 00-3-3.87" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);
const IconVentas = () => (
  <svg viewBox="0 0 24 24" fill="none" width="18" height="18">
    <line x1="12" y1="1" x2="12" y2="23" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M17 5H9.5a3.5 3.5 0 100 7h5a3.5 3.5 0 110 7H6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);
const IconPuntos = () => (
  <svg viewBox="0 0 24 24" fill="none" width="18" height="18">
    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
  </svg>
);
const IconBoletin = () => (
  <svg viewBox="0 0 24 24" fill="none" width="18" height="18">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12a2 2 0 01-2 2H4a2 2 0 01-2-2V6c0-1.1.9-2 2-2z" stroke="currentColor" strokeWidth="2"/>
    <path d="M22 6l-10 7L2 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);
const IconConfig = () => (
  <svg viewBox="0 0 24 24" fill="none" width="18" height="18">
    <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2"/>
    <path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z" stroke="currentColor" strokeWidth="2"/>
  </svg>
);
const IconLogout = () => (
  <svg viewBox="0 0 24 24" fill="none" width="17" height="17">
    <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <polyline points="16 17 21 12 16 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <line x1="21" y1="12" x2="9" y2="12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);
const IconMenu = () => (
  <svg viewBox="0 0 24 24" fill="none" width="22" height="22">
    <line x1="3" y1="6" x2="21" y2="6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <line x1="3" y1="12" x2="21" y2="12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <line x1="3" y1="18" x2="15" y2="18" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);
const IconExternalLink = () => (
  <svg viewBox="0 0 24 24" fill="none" width="13" height="13">
    <path d="M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M15 3h6v6M10 14L21 3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const IconLeads = () => (
    <svg viewBox="0 0 24 24" fill="none" width="18" height="18">
      <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
      <circle cx="9" cy="7" r="4" stroke="currentColor" strokeWidth="2"/>
      <path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    </svg>
  );

  const IconDownload = () => (
    <svg viewBox="0 0 24 24" fill="none" width="18" height="18">
      <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <polyline points="7 10 12 15 17 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <line x1="12" y1="15" x2="12" y2="3" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    </svg>
  );

  const IconPedidos = () => (
    <svg viewBox="0 0 24 24" fill="none" width="16" height="16">
      <path d="M3 7h18" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
      <path d="M6 7V5a2 2 0 012-2h8a2 2 0 012 2v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
      <rect x="3" y="7" width="18" height="13" rx="2" stroke="currentColor" strokeWidth="2"/>
      <path d="M8 12h8M8 16h5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    </svg>
  );

  const IconBox = () => (<svg viewBox="0 0 24 24" fill="none" width="18" height="18"><path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><polyline points="3.27 6.96 12 12.01 20.73 6.96" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><line x1="12" y1="22.08" x2="12" y2="12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
  
  const IconBook = () => (
    <svg viewBox="0 0 24 24" fill="none" width="18" height="18">
      <path d="M4 19.5A2.5 2.5 0 016.5 17H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
      <path d="M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15A2.5 2.5 0 016.5 2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    </svg>
  );

  const IconSlides = () => (<svg viewBox="0 0 24 24" fill="none" width="18" height="18"><rect x="2" y="7" width="20" height="10" rx="2" stroke="currentColor" strokeWidth="2"/><path d="M6 7V5M18 7V5M6 17v2M18 17v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);

  const IconReportes = () => (
    <svg viewBox="0 0 24 24" fill="none" width="18" height="18">
      <path d="M18 20V10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M12 20V4"  stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M6 20v-6"  stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );


  const IconCupon = () => (
    <svg viewBox="0 0 24 24" fill="none" width="18" height="18">
      <path d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <line x1="7" y1="7" x2="7.01" y2="7" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    </svg>
  );

  const IconArticulos = () => (
    <svg viewBox="0 0 24 24" fill="none" width="18" height="18">
      <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M14 2v6h6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
      <path d="M16 13H8M16 17H8M10 9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    </svg>
  );


  const IconMsg = () => (
    <svg viewBox="0 0 24 24" fill="none" width="18" height="18">
      <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );

  const IconReceipt = () => <svg viewBox="0 0 24 24" fill="none" width="15" height="15"><path d="M4 2v20l3-2 2 2 3-2 3 2 2-2 3 2V2l-3 2-2-2-3 2-3-2-2 2-3-2z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/><line x1="8" y1="9" x2="16" y2="9" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><line x1="8" y1="13" x2="16" y2="13" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>;

  const IconSecciones = () => <svg viewBox="0 0 24 24" fill="none" width="15" height="15"><rect x="3" y="3" width="18" height="5" rx="1" stroke="currentColor" strokeWidth="2"/><rect x="3" y="11" width="18" height="5" rx="1" stroke="currentColor" strokeWidth="2"/><rect x="3" y="19" width="18" height="2" rx="1" stroke="currentColor" strokeWidth="2"/></svg>;

/* ── Nav items ── */
const navItems = [
  { to: '/admin/dashboard',    label: 'Dashboard',    Icon: IconDashboard },
  { to: '/admin/hero-carrusel', label: 'Hero / Carrusel', Icon: IconSlides },
  { to: '/admin/formaciones',  label: 'Cursos',  Icon: IconFormaciones },
  { to: '/admin/recursos',     label: 'Materiales',         Icon: IconBox },   // ← AGREGAR
    { to: '/admin/recursos-gratis', label: 'Mat. Gratuitos', Icon: IconDownload },
    { to: '/admin/usuarios',     label: 'Usuarios',     Icon: IconUsuarios },

  { to: '/admin/suscriptores', label: 'Suscriptores', Icon: IconUsuarios },
  { to: '/admin/pedidos', label: 'Pedidos', Icon: IconPedidos },
  { to: '/admin/puntos', label: 'Puntos', Icon: IconPuntos },
  { to: '/admin/cupones', label: 'Cupones', Icon: IconCupon },
  { to: '/admin/secciones', label: 'Secciones', Icon: IconSecciones },
  { to: '/admin/comprobantes', label: 'Comprobantes', Icon: IconReceipt },

  { to: '/admin/reclamaciones',    label: 'Reclamaciones',   Icon: IconBook },
  { to: '/admin/articulos',    label: 'Blog',   Icon: IconArticulos },
  { to: '/admin/articulos-comentarios', label: 'Comentarios', Icon: IconMsg },


  { to: '/admin/reportes', label: 'Reportes', Icon: IconReportes },



];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  const initials = user?.name
    ? user.name.split(' ').map(w => w[0]).join('').slice(0,2).toUpperCase()
    : 'AD';

  return (
    <div className={`al-layout ${collapsed ? 'al-layout--collapsed' : ''} ${mobileOpen ? 'al-layout--mob-open' : ''}`}>

      {/* Overlay mobile */}
      {mobileOpen && (
        <div className="al-overlay" onClick={() => setMobileOpen(false)} />
      )}

      {/* ── SIDEBAR ── */}
      <aside className={`al-sidebar ${collapsed ? 'al-sidebar--collapsed' : ''}`}>
      
      
      <div className="al-sidebar__top">
      <a href="/" className="al-sidebar__logo">
            <img
              src="/images/logo_centro.png"
              alt="Comunicar"
              style={{
                height: collapsed ? 22 : 30,
                maxWidth: collapsed ? 22 : 120,
              }}
            />
          </a>

          <button
            className="al-sidebar__collapse"
            onClick={() => setCollapsed(c => !c)}
            aria-label="Colapsar menú"
          >
            <IconMenu />
          </button>
        </div>

        {!collapsed && (
          <p className="al-sidebar__section-label">Menú principal</p>
        )}

        <nav className="al-sidebar__nav">
          {navItems.map(({ to, label, Icon }) => (
            <NavLink
              key={to}
              to={to}
              className={({ isActive }) =>
                `al-nav-item ${isActive ? 'al-nav-item--active' : ''}`
              }
              title={collapsed ? label : undefined}
            >
              <span className="al-nav-item__icon"><Icon /></span>
              {!collapsed && <span className="al-nav-item__label">{label}</span>}
            </NavLink>
          ))}
        </nav>

        {!collapsed && (
          <div className="al-sidebar__section-label al-sidebar__section-label--mt">
            Configuración
          </div>
        )}
        <NavLink
          to="/admin/configuracion"
          className={({ isActive }) => `al-nav-item ${isActive ? 'al-nav-item--active' : ''}`}
          title={collapsed ? 'Configuración' : undefined}
        >
          <span className="al-nav-item__icon"><IconConfig /></span>
          {!collapsed && <span className="al-nav-item__label">Configuración</span>}
        </NavLink>

        {/* Ver sitio */}
        {!collapsed && (
          <a
            href="/"
            target="_blank"
            rel="noopener noreferrer"
            className="al-sidebar__site-link"
          >
            <IconExternalLink /> Ver sitio web
          </a>
        )}

        {/* User + logout */}
        <div className="al-sidebar__user">
          <div className="al-sidebar__avatar">{initials}</div>
          {!collapsed && (
            <div className="al-sidebar__user-info">
              <strong>{user?.name || 'Admin'}</strong>
              <span>Administrador</span>
            </div>
          )}
          <button
            className="al-sidebar__logout"
            onClick={handleLogout}
            title="Cerrar sesión"
          >
            <IconLogout />
          </button>
        </div>
      </aside>

      {/* ── MAIN ── */}
      <div className="al-main">
        {/* Topbar mobile */}
        <div className="al-topbar">
          <button
            className="al-topbar__menu"
            onClick={() => setMobileOpen(o => !o)}
          >
            <IconMenu />
          </button>
          <a href="/" className="al-topbar__logo">
            <span className="al-sidebar__logo-mark" />Comunicar Admin
          </a>
          <div className="al-topbar__user">
            <div className="al-sidebar__avatar al-sidebar__avatar--sm">{initials}</div>
          </div>
        </div>

        {/* Page content */}
        <div className="al-content">
          <Outlet />
        </div>
      </div>
    </div>
  );
}